import {
    IProfileState,
    initialProfileState
} from './profile-state';

export function reducer(state: IProfileState = initialProfileState(), action: any): IProfileState {        
      
    switch (action.type) {
        default:
            return state;
    }
}
